import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { ImportDatosAccesoriosComponent } from "./import-datos-accesorios.component";
import { UploadingPageComponent } from "./uploading-page/uploading-page.component";

const routesImportDatosAccesorios: Routes = [
  {
    path: "",
    component: ImportDatosAccesoriosComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "upload",
        component: UploadingPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesImportDatosAccesorios)],
  exports: [RouterModule],
})
export class ImportDatosAccesoriosRoutingModule {}
